import React, { FC, ReactNode } from 'react';

import { LucidTheme } from '@lucid/theme';

import Link from '../../link/link';

export interface CMSNodeButtonProps {
  /** The children for the link, usually the label. */
  children?: ReactNode;
  /** The URL to the CMS specific node in Drupal. */
  href: string;
  /** The label for the button. */
  label?: string;
}

const CMSNodeButton: FC<CMSNodeButtonProps> = ({ children, href, label = 'Edit Page' }) => (
  <Link
    css={(theme: LucidTheme) => ({
      position: 'fixed',
      bottom: '2rem',
      right: '2rem',
      border: `1px solid ${theme.colors.white}`,
      padding: '0.5rem 3rem',
      borderRadius: theme.radii.base,
      zIndex: theme.zIndices.zMax,
      background: `linear-gradient(to left, ${theme.colors.red[30]}, ${theme.colors.orange[10]})`,
      color: theme.colors.white,
      transition: 'opacity 0.25s ease',
      opacity: 0.4,
      '&:hover': {
        opacity: 1,
        color: theme.colors.black
      }
    })}
    data-name="cms-edit-link"
    href={href}
  >
    {children || label}
  </Link>
);

export { CMSNodeButton };
export default CMSNodeButton;
